export const data = [
    {
        "id": 1,
        "image": "https://via.placeholder.com/200",
        "title": "Verduras y Frutas"
    },
    {
        "id": 2,
        "image": "https://via.placeholder.com/200",
        "title": "Carnes"
    },
    {
        "id": 3,
        "image": "https://via.placeholder.com/200",
        "title": "Mercados"
    },
    {
        "id": 4,
        "image": "https://via.placeholder.com/200",
        "title": "Restaurantes y Bares"
    },
    {
        "id": 5,
        "image": "https://via.placeholder.com/200",
        "title": "Mascotas"
    },
    {
        "id": 6,
        "image": "https://via.placeholder.com/200",
        "title": "Librerias"
    },
    {
        "id": 7,
        "image": "https://via.placeholder.com/200",
        "title": "VCafe y Té"
    },
    {
        "id": 8,
        "image": "https://via.placeholder.com/200",
        "title": "Servicios"
    },
]